import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators, } from '@angular/forms';
import { PreSelectBox } from '../../../../../sg-kc-shared/constants/preSelectBox';

/** 確定使用量再取込画面（検索条件）
 * @export
 * @class Sgkc051dSearchConditionComponent
 * @implements { OnInit, OnDestroy, OnChanges }
 */
@Component({
    selector: 'app-sgkc051d-search-condition',
    templateUrl: './sgkc051d-search-condition.component.html',
    styleUrl: './sgkc051d-search-condition.component.scss',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkc051dSearchConditionComponent implements OnInit, OnDestroy, OnChanges {

    /** 初期値 */
    readonly DEFAULT_VALUE = '';

    /** input用 ステータスのセレクトボックスデータ */
    @Input() inputStatusList: PreSelectBox[] = [];

    /** 検索ボタン押下イベント */
    @Output() onClickSearchEvent = new EventEmitter<void>();
    /** クリアボタン押下イベント */
    @Output() onClickClearEvent = new EventEmitter<UntypedFormGroup>();

    /** 親コンポーネント保持領域 */
    parentForm: UntypedFormGroup;
    /** 検索情報格納FormGroup */
    childReimportUsageConditionInfo: UntypedFormGroup;

    /** 供給地点特定番号 */
    suppntSpno: UntypedFormControl = new UntypedFormControl({ value: null, disabled: false }, [Validators.required, Validators.pattern(/^(\d{17}|\d{22})$/)]);
    /** ステータス */
    status: UntypedFormControl = new UntypedFormControl({ value: null, disabled: false });

    /** ステータスのセレクトボックスデータ */
    searchStatusList: PreSelectBox[] = [];

    /**
     * コンストラクタ
     * @param {FormBuilder} fb
     * @param {FormGroupDirective} parent
     * @memberof Sgkc051dSearchConditionComponent
     */
    constructor(
        private fb: UntypedFormBuilder,
        private parent: FormGroupDirective) { }

    /** 
     * 初期処理
     * @memberof Sgkc051dSearchConditionComponent
     */
    ngOnInit(): void {

        // 検索情報格納FormGroupを設定する
        this.childReimportUsageConditionInfo = this.fb.group({
            suppntSpno: this.suppntSpno,
            status: this.status
        });

        this.parentForm = this.parent.form;
        this.parentForm.addControl('childReimportUsageConditionInfo', this.childReimportUsageConditionInfo);
    }

    /** 
     * コンポーネント破棄時の処理
     * @memberof Sgkc051dSearchConditionComponent
     */
    ngOnDestroy(): void {
        if (this.parentForm) {
            this.parentForm.clearValidators();
            this.parentForm.updateValueAndValidity();
            this.parentForm.removeControl('childReimportUsageConditionInfo');
        }
    }

    /**
     * 親コンポーネントから受け取った値を更新する。
     * @memberof Sgkc051dSearchConditionComponent
     */
    ngOnChanges() {

        if (this.inputStatusList) {

            this.searchStatusList = this.inputStatusList;

            // 先頭にステータスの初期値を追加
            const defaultValue: PreSelectBox = { value: this.DEFAULT_VALUE, viewValue: this.DEFAULT_VALUE, hyojiRowTurn: this.DEFAULT_VALUE };
            this.searchStatusList.unshift(defaultValue);
        }
    }

    /** 
     * 検索ボタン押下処理
     * @memberof Sgkc051dSearchConditionComponent
     */
    onClickSearch(): void {
        this.onClickSearchEvent.emit();
    }

    /** 
     * クリアボタン押下処理
     * @memberof Sgkc051dSearchConditionComponent
     */
    onClickClear(): void {

        // 検索条件フォーム初期化
        this.suppntSpno = new UntypedFormControl({ value: null, disabled: false }, [Validators.required, Validators.pattern(/^(\d{17}|\d{22})$/)]);
        this.status = new UntypedFormControl({ value: null, disabled: false });

        // 検索情報格納フォーム初期化
        this.childReimportUsageConditionInfo = this.fb.group({
            suppntSpno: this.suppntSpno,
            status: this.status
        });

        // 親コンポーネントのコントロール初期化
        this.parentForm.removeControl('childReimportUsageConditionInfo');
        this.parentForm.addControl('childReimportUsageConditionInfo', this.childReimportUsageConditionInfo);

        this.onClickClearEvent.emit(this.parentForm);
    }
}
